import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/Page/Home.vue";

const routes = [
  // common routes
  {
    path: "/home",
    name: "home",
    component: HomeView,
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("../views/Page/Profile/Profile.vue"),
  },

  {
    path: "/business-information",
    name: "BusinessInformation",
    component: () => import("../views/Page/Profile/BusinessInfo.vue"),
  },
  {
    path: "/company-information",
    name: "CompanyInformation",
    component: () => import("../views/Page/Profile/CompanyInfo.vue"),
  },

  {
    path: "/oprational-information",
    name: "OprationalInformation",
    component: () => import("../views/Page/Profile/OprationalInformation.vue"),
  },

  {
    path: "/add-new-container-on-wheel",
    name: "NewContainerOnWheel",
    component: () => import("../views/Page/Container/wheel.vue"),
    meta: { Role: "Transporter" },
  },
  {
    path: "/edit-container-on-wheel/:id",
    name: "EditContainerOnWheel",
    component: () => import("../views/Page/Container/EditContainerOnWheel.vue"),
    meta: { Role: "Transporter" },
  },
  // update new url 
  {
    path: "/edit-shippingline-info/:id",
    name: "EditParentContainerInfo",
    component: () => import("../views/Page/Container/EditContainerNew/EditParentContainerInfo.vue"),
    meta: { Role: "Transporter" },
  },
  {
    path: "/edit-container-info/:id",
    name: "EditChiledContainerInfo",
    component: () => import("../views/Page/Container/EditContainerNew/EditChiledContainerInfo.vue"),
    meta: { Role: "Transporter" },
  },
 
  {
    path: "/view-more-list/:id",
    name: "ViewMoreList",
    component: () => import("../views/Page/Container/ViewMoreList.vue"),
    meta: { Role: "Transporter" },
  },
  {
    path: "/active-containers",
    name: "ActiveContainers",
    component: () => import("../views/Page/Container/ContainerList.vue"),
    meta: { Role: "Transporter" },
  },


  {
    path: "/notification-list",
    name: "NotificationList",
    component: () => import("../views/Page/Notifications/Notification.vue"),
  },

  // For Transporter

  {
    path: "/booking-details/:id",
    name: "BookingDetails",
    component: () =>
      import("../views/Page/Transporter/Bookings/BookingDetails.vue"),
    meta: { Role: "Transporter" },
  },

  {
    path: "/history",
    name: "History",
    component: () => import("../views/Page/Transporter/History/History.vue"),
    meta: { Role: "Transporter" },
  },

  {
    path: "/container-under-booking",
    name: "CcontainerUnderBooking",
    component: () =>
      import(
        "../views/Page/Transporter/TransporterBooking/ContainerUnderBooking.vue"
      ),
    meta: { Role: "Transporter" },
  },

  {
    path: "/container-under-booking-detail/:id",
    name: "ContainerUnderBookingDetail",
    component: () =>
      import(
        "../views/Page/Transporter/TransporterBooking/ContainerUnderBookingDetail.vue"
      ),
    meta: { Role: "Transporter" },
  },
  {
    path: "/send-photos/:id",
    name: "SendPhotos",
    component: () =>
      import("../views/Page/Transporter/TransporterBooking/SendPhotos.vue"),
    meta: { Role: "Transporter" },
  },

  {
    path: "/linking-request/:id",
    name: "TransporterLinkingRequest",
    component: () =>
      import("../views/Page/Transporter/TransporterBooking/LinkingRequest.vue"),
    meta: { Role: "Transporter" },
  },

  {
    path: "/start-moving-towords-exporter/:id",
    name: "StartMovingTowordsExporter",
    component: () =>
      import(
        "../views/Page/Transporter/TransporterBooking/StartMovingTowordsExporter.vue"
      ),
    meta: { Role: "Transporter" },
  },

  {
    path: "/exporter-details/:id",
    name: "ExporterDetails",
    component: () =>
      import(
        "../views/Page/Transporter/TransporterBooking/ExporterDetails.vue"
      ),
    meta: { Role: "Transporter" },
  },

  {
    path: "/on-way-to-exporter/:id",
    name: "OnWayToExporter",
    component: () =>
      import(
        "../views/Page/Transporter/TransporterBooking/OnWayToExporter.vue"
      ),
    meta: { Role: "Transporter" },
  },
  {
    path: "/upload-invoice-and-lori-recipt/:id",
    name: "UploadInvoiceAndLR",
    component: () =>
      import(
        "../views/Page/Transporter/TransporterBooking/UploadInvoiceAndLR.vue"
      ),
    meta: { Role: "Transporter" },
  },
  {
    path: "/trip-close/:id",
    name: "TripClose",
    component: () =>
      import("../views/Page/Transporter/TransporterBooking/TripClose.vue"),
    meta: { Role: "Transporter" },
  },

  {
    path: "/reject-or-cancel/:id",
    name: "RejectedOrCancelled",
    component: () =>
      import(
        "../views/Page/Transporter/TransporterBooking/RejectedOrCancelled.vue"
      ),
    meta: { Role: "Transporter" },
  },

  {
    path: "/payment-pending",
    name: "TransporterPaymentPending",
    component: () =>
      import("../views/Page/Transporter/Payment/PaymentPending.vue"),
    meta: { Role: "Transporter" },
  },

  {
    path: "/reuse-container/add-details",
    name: "/AddDetails",
    component: () =>
      import("../views/Page/Transporter/ReuseContainer/AddDetails.vue"),
    meta: { Role: "Any-Not-ShippingLine" },
  },

  {
    path: "/reuse-container/edit-details/:id",
    meta: { Role: "Any-Not-ShippingLine" },
    component: () =>
      import("../views/Page/Transporter/ReuseContainer/EditDetails.vue"),
    meta: { Role: "Any-Not-ShippingLine" },
  },

  {
    path: "/reuse-container/linking-request",
    name: "/ReuseContainerLinkingRequest",
    component: () =>
      import("../views/Page/Transporter/ReuseContainer/LinkingRequest.vue"),
    meta: { Role: "Any-Not-ShippingLine" },
  },

  {
    path: "/reuse-container/linking-payments",
    name: "/ReuseLinkingPaymnets",
    component: () =>
      import("../views/Page/Transporter/ReuseContainer/LinkingPaymnets.vue"),
    meta: { Role: "Any-Not-ShippingLine" },
  },

  {
    path: "/reuse-container/linking-payments-details/:id",
    name: "/LinkingPaymnetsDetails",
    component: () =>
      import(
        "../views/Page/Transporter/ReuseContainer/LinkingPaymnetsDetails.vue"
      ),
      meta: { Role: "Any-Not-ShippingLine" },
  },

  {
    path: "/reuse-container/history",
    name: "/ReuseHistory",
    component: () =>
      import("../views/Page/Transporter/ReuseContainer/History.vue"),
    meta: { Role: "Any-Not-ShippingLine" },
  },

  // Delinking Process
  {
    path: "/reuse-container/delinking-request-list",
    name: "/ReuseDeLinkingList",
    component: () =>
      import("../views/Page/Transporter/ReuseContainer/DeLinking.vue"),
    meta: { Role: "Any-Not-ShippingLine" },
  },
  {
    path: "/reuse-container/delinking-request-history",
    name: "/ReuseDeLinkingHistory",
    component: () =>
      import("../views/Page/Transporter/ReuseContainer/DeLinkingHistory.vue"),
    meta: { Role: "Any-Not-ShippingLine" },
  },

  // Exporter Routes

  {
    path: "/container-search",
    name: "ContainerSearch",
    component: () => import("../views/Page/Container/SearchContainer.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  {
    path: "/containers",
    name: "InfoSearchContainePrice",
    component: () =>
      import("../views/Page/Container/InfoSearchContainePrice.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  {
    path: "/make-booking-container/:id",
    name: "BookingContainer",
    component: () => import("../views/Page/Container/BookingContainer.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },
  {
    path: "/confirme-booking",
    name: "ConfirmBooking",
    component: () => import("../views/Page/Container/ConfirmBooking.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  {
    path: "/booking-list-exporter",
    name: "BookingListExporter",
    component: () => import("../views/Page/Exporter/BookingList.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  {
    path: "/container-photo/:id",
    name: "ContainerPhotos",
    component: () => import("../views/Page/Exporter/ContainerPhotos.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  {
    path: "/payment-page",
    name: "PaymentBooking",
    component: () => import("../views/Page/Exporter/PaymentBooking.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },
  {
    path: "/exporter-container-under-booking",
    name: "CcontainerUnderBookingExporter",
    component: () =>
      import(
        "../views/Page/Exporter/ExporterBooking/ContainerUnderBooking.vue"
      ),
      meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  {
    path: "/exporter-booking-request/:id",
    name: "ExporterBookingRequest",
    component: () =>
      import("../views/Page/Exporter/ExporterBooking/BookingRequest.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },
  {
    path: "/exporter-container-photos/:id",
    name: "ContainerPhotos",
    component: () =>
      import("../views/Page/Exporter/ExporterBooking/ContainerPhotos.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  {
    path: "/exporter-linking-request/:id",
    name: "LinkingRequest",
    component: () =>
      import("../views/Page/Exporter/ExporterBooking/LinkingRequest.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  {
    path: "/exporter-linking-payments/:id",
    name: "LinkingPayment",
    component: () =>
      import("../views/Page/Exporter/ExporterBooking/LinkingPayment.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  {
    path: "/transporter-detaile-page/:id",
    name: "TransporterDetails",
    component: () =>
      import("../views/Page/Exporter/ExporterBooking/TransporterDetails.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  {
    path: "/exporter-container-reached/:id",
    name: "ContainerReached",
    component: () =>
      import("../views/Page/Exporter/ExporterBooking/ContainerReached.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },
  {
    path: "/exporter-download-invoice/:id",
    name: "DownloadInvoice",
    component: () =>
      import("../views/Page/Exporter/ExporterBooking/DownloadInvoice.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },
  {
    path: "/exporter-trip-close/:id",
    name: "ExporterTripClose",
    component: () =>
      import("../views/Page/Exporter/ExporterBooking/TripClose.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  {
    path: "/exporter-reject-or-cancel/:id",
    name: "ExpporterRejectedOrCancelled",
    component: () =>
      import("../views/Page/Exporter/ExporterBooking/RejectedOrCancelled.vue"),

    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  {
    path: "/exporter-history",
    name: "ExporterHistory",
    component: () => import("../views/Page/Exporter/History/History.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  {
    path: "/exporter-payment-pending",
    name: "ExporterPaymentPending",
    component: () =>
      import("../views/Page/Exporter/Payment/PaymentPending.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  {
    path: "/thank-you-booking-page",
    name: "ExporterThankyouPage",
    component: () =>
      import("../views/Page/Exporter/Thankyou/ExporterThankYou.vue"),
    meta: { Role: "Any-Not-Transporetr-ShippingLine" },
  },

  // Shipping  Line Routes

  {
    path: "/linking-request-received",
    name: "LinkingRequestReceived",
    component: () =>
      import(
        "../views/Page/ShipingLine/ShipingLineBooking/LinkingRequestReceived.vue"
      ),
      meta: { Role: "Ocean Carrier" },
  },
  {
    path: "/delinking-request-received",
    name: "DeLinkingRequestReceived",
    component: () =>
      import(
        "../views/Page/ShipingLine/ShipingLineBooking/DelinkingRequestReceived.vue"
      ),
      meta: { Role: "Ocean Carrier" },
  },
  {
    path: "/shipping-line-history",
    name: "ShippingLineHistory",
    component: () => import("../views/Page/ShipingLine/History/History.vue"),
    meta: { Role: "Ocean Carrier" },
  },

  // reuse container

  {
    path: "/reuse-container/linking-request-history",
    name: "/ReuseContainerShippingLineHistory",
    component: () =>
      import("../views/Page/ShipingLine/ReuseContainer/History.vue"),
    meta: { Role: "Ocean Carrier" },
  },

  {
    path: "/reuse-container/linking-request-received",
    name: "/ReuseContainerLinkingRequestReceivedShippingLine",
    component: () =>
      import("../views/Page/ShipingLine/ReuseContainer/LinkingRequest.vue"),
    meta: { Role: "Ocean Carrier" },
  },

  {
    path: "/reuse-container/delinking-request-received",
    name: "DelinkingRequestRecived",
    component: () =>
      import("../views/Page/ShipingLine/ReuseContainer/DelinkingRequest.vue"),
    meta: { Role: "Ocean Carrier" },
  },
  {
    path: "/reuse-container/shippingline-delinking-history",
    name: "DelinkingHistory",
    component: () =>
      import("../views/Page/ShipingLine/ReuseContainer/DelinkingHistory.vue"),
    meta: { Role: "Ocean Carrier" },
  },



  // Auth Section

  {
    path: "/help-and-support",
    name: "HelpAndSupport",
    component: () => import("../views/Page/HelpAndSupport/HelpAndSupport.vue"),
    
  },
  {
    path: "/privacy-and-policy",
    name: "PrivecyAndPolicy",
    component: () => import("../views/ImportantDocc/PrivecyAndPolicy.vue"),
  },
  {
    path: "/terms-and-conditions",
    name: "TurmsAndCondition",
    component: () => import("../views/ImportantDocc/TurmsAndCondition.vue"),
  },
  {
    path: "/set-new-password/:random",
    name: "SetNewPassword",
    component: () =>
      import(
        /* webpackChunkName: "SetNewPassword" */ "../views/Auth/SetNewPassword.vue"
      ),
      meta: {
        sidebarVisible: false,
        headerVisible: false,
        footerVisible: false,
      },
  },
  {
    path: "/reset-password/:random",
    name: "ResetPassword",
    component: () =>
      import(
        /* webpackChunkName: "ResetPassword" */ "../views/Auth/ResetPassword.vue"
      ),
      meta: {
        sidebarVisible: false,
        headerVisible: false,
        footerVisible: false,
      },
  },
  {
    path: "/registeration",
    name: "Registeration",
    component: () => import("../views/Page/Registeration.vue"),
    meta: {
      sidebarVisible: false,
      headerVisible: false,
      footerVisible: false,
    },
  },
  {
    path: "/register-your-account",
    name: "Register",
    component: () => import("../views/Auth/Register.vue"),
    meta: {
      sidebarVisible: false,
      headerVisible: false,
      footerVisible: false,
    },
  },
  {
    path: "/",
    name: "HomeLogin",
    component: () => import("../views/Auth/Login.vue"),
    meta: {
      sidebarVisible: false,
      headerVisible: false,
      footerVisible: false,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Auth/Login.vue"),
    meta: {
      sidebarVisible: false,
      headerVisible: false,
      footerVisible: false,
    },
  },
  {
    path: "/forget-password",
    name: "ForgetPassword",
    component: () => import("../views/Auth/ForgetPassword.vue"),
    meta: {
      sidebarVisible: false,
      headerVisible: false,
      footerVisible: false,
    },
  },
  {
    path: "/otp-verification",
    name: "OtpVirification",
    component: () => import("../views/Auth/OtpVirification.vue"),
    meta: {
      sidebarVisible: false,
      headerVisible: false,
      footerVisible: false,
    },
  },
  {
    path: "/mobile-otp-verification",
    name: "MobileOtpLogin",
    component: () => import("../views/Auth/MobileOtpLogin.vue"),
    meta: {
      sidebarVisible: false,
      headerVisible: false,
      footerVisible: false,
    },
  },
  {
    path: "/error-404",
    name: "Error404",
    component: () => import("@/views/Error/Error404.vue"),
    meta: {
      sidebarVisible: false,
      headerVisible: false,
      footerVisible: false,
    },
  },
  {
    // path: '*',
    path: "/:catchAll(.*)", // Unrecognized path automatically matches 404
    redirect: "/error-404",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
